import React from 'react'
import {getDashboardCompetitionList, getDashboardCompetition,getArtikelTags} from 'actions'
import {Divider, IconButton, useTheme, Button, Card} from '@material-ui/core'
import {VideogameAssetOutlined} from '@material-ui/icons'
import {history} from "store"
import CustomScrollbars from './CustomDashboardScrollbar'
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import DashBoardTavlingItem from './DashboardTavlingItem'
import {useSelector, useDispatch} from 'react-redux'
import {ArrowForwardIos, ArrowBackIos} from '@material-ui/icons'
import { isEmpty, isUndefined } from 'lodash'
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);


export default function DashboardTävlingar(props) {
  const dispatch = useDispatch()

  const DashboardCompetitionList = useSelector(state => state.DashBoard.DashboardCompetitionList)
  const DashboardCompetitionLoading = useSelector(state => state.DashBoard.DashboardCompetitionLoading)
  const currentDashboardCompetition = useSelector(state => state.DashBoard.currentDashboardCompetition)
  const Userid = useSelector(state => state.auth.authUser.user_id)
  const Afid = useSelector(state => state.auth.authUser.user_Afid)

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [currentDashboardState, setCurrentDashboardState] = React.useState({})

  const handleStepChange = (step) => {
    // console.log(step)
    if(!isEmpty(DashboardCompetitionList)) {
      let fetchThisDashboard = DashboardCompetitionList.filter(d => parseInt(d.Finished)===0)[step]
      if(DashboardCompetitionList.filter(d => parseInt(d.Finished)===0).length > 1) setCurrentDashboardState({})
      if(!isUndefined(fetchThisDashboard)) {
        dispatch(getDashboardCompetition(Userid, Afid, fetchThisDashboard.id))
      }
    }
    setActiveStep(step);
  };

  React.useEffect(() => {
    dispatch(getDashboardCompetitionList(Userid,Afid))
    dispatch(getArtikelTags(Afid,Userid))
  }, [])

  React.useEffect(() => {
    if(!isEmpty(currentDashboardCompetition)) setCurrentDashboardState(currentDashboardCompetition)
  },[currentDashboardCompetition, DashboardCompetitionLoading])

  React.useEffect(() => {
    if(!isEmpty(DashboardCompetitionList)) { 
      let fetchThisDashboard = DashboardCompetitionList.filter(d => parseInt(d.Finished)===0)[0]
      if(!isUndefined(fetchThisDashboard)) {
        dispatch(getDashboardCompetition(Userid, Afid, fetchThisDashboard.id))
      }
    }
  }, [DashboardCompetitionList])

  const handleChangeStep = (stepChange) => {
    let __step = DashboardCompetitionList.filter(d => parseInt(d.Finished)===0)[stepChange]

    if(!isUndefined(__step)) handleStepChange(stepChange)
    if(stepChange > activeStep && isUndefined(__step)) handleStepChange(0)
    if(stepChange < activeStep && isUndefined(__step)) handleStepChange(DashboardCompetitionList.filter(d => parseInt(d.Finished)===0).length-1)
  }

  const handleGetCompetition = (id) => {
    dispatch(getDashboardCompetition(Userid, Afid, id))
    history.push({pathname:"/app/DashboardTavling", state: {CompId: id}})
  } 
  if(isEmpty(DashboardCompetitionList.filter(d => parseInt(d.Finished)===0))) return ''
  return (
    <Card className={props.classes.tavlingBg}elevation={3}>
      <span className="text">
      <div className="h-100 d-flex flex-column align-items-center postition-relative">
        <div className='h-100 w-100 position-relative' style={{top:0,left:0}}>
          <div className='text-white px-2 pt-1 font-weight-bold text-align-center d-flex align-items-center w-100 justify-content-between' style={{fontSize: 19}}>
            {
              DashboardCompetitionList.filter(d => parseInt(d.Finished)===0).length>1?
              <IconButton size="small" color="primary" onClick={() => handleChangeStep(activeStep-1)}>
                <ArrowBackIos/>
              </IconButton>:<div></div>
            }
            {
              !isUndefined(DashboardCompetitionList.filter(d => parseInt(d.Finished)===0)[activeStep]) &&
              <Button size="small" color="primary" style={{fontSize: 18, fontWeight:500, height:30}} className='text-white' onClick={() => handleGetCompetition(DashboardCompetitionList.filter(d => parseInt(d.Finished)===0)[activeStep].id)}>{isEmpty(currentDashboardState) ? '' : currentDashboardState.Name}</Button>
            }
            {
              DashboardCompetitionList.filter(d => parseInt(d.Finished)===0).length>1?
              <IconButton size="small" color="primary" onClick={() => handleChangeStep(activeStep+1)}>
                <ArrowForwardIos/>
              </IconButton>:<div></div>
            }
          </div>
            <AutoPlaySwipeableViews
                interval={15000}
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                className='w-100'
                style={{height: 270}}
                containerStyle={{height: 270}}
              >
                {
                  DashboardCompetitionList.filter(d => parseInt(d.Finished)===0).map((c, index) => {
                    return (
                      <DashBoardTavlingItem key={c.id} Competition={c} currentDashboardCompetition={currentDashboardState} handleStepChange={handleStepChange} listLength={DashboardCompetitionList.filter(d => parseInt(d.Finished)===0).length}/>
                    )
                  })
                }
            </AutoPlaySwipeableViews>
          </div>
        </div>
      </span>
    </Card>
  )
}
